import { render, staticRenderFns } from "./VisitSummaryTable.vue?vue&type=template&id=a95a0092&scoped=true"
import script from "./VisitSummaryTable.vue?vue&type=script&lang=ts"
export * from "./VisitSummaryTable.vue?vue&type=script&lang=ts"
import style0 from "./VisitSummaryTable.vue?vue&type=style&index=0&id=a95a0092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a0092",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/observation/visit/visit-summary/visit-summary-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fobservation%2Fvisit%2Fvisit-summary%2FVisitSummaryTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports